const detail =
`<p>欢迎使用杭州笑口杏信息科技有限公司运营的平台服务。为使用本平台服务，您应当阅读并遵守《用户注册协议》和《隐私政策》。本协议是您与杭州笑口杏信息科技有限公司之间就平台注册、登录、信息发布、浏览使用及其他相关服务所订立的协议。请您务必审慎阅读、充分理解各条款内容。除非您已阅读并接受本协议全部条款，否则您无权使用本平台提供的服务；您使用本平台服务即视为您已阅读并同意受本协议约束。</p>
<p class="bold">1.接受条款</p>
<p>1.1.本平台系指由杭州笑口杏信息科技有限公司运营的网站、客户端及相关服务载体。我们依据本用户注册协议及依法发布的规则，为您提供基于互联网及移动互联网的相关服务。</p>
<p>1.2.您应按照注册页面的提示填写信息、阅读并点击同意本协议，完成注册流程后，即成为本平台用户（以下简称“用户”或“您”），并受本协议约束。本协议自您完成勾选同意并成功注册之日起在您与杭州笑口杏信息科技有限公司之间产生法律效力。</p>
<p>1.3.本协议是您与本平台之间关于使用平台服务所订立的基础协议，适用于本平台提供的全部服务。您使用本平台单项服务时，还应遵守本平台因法律法规变化、业务发展需要而发布的相关指引、规则、公告等，前述内容均构成本协议的组成部分。</p>
<p>1.4.用户应遵守本协议各项条款，合法、合理、审慎地使用本平台提供的服务，否则本平台有权依据本协议采取限制功能、删除内容、中断或终止服务等处理措施。</p>
<p class="bold">2.服务内容</p>
<p>2.1.本平台向用户提供包括但不限于广告策划、企业咨询、数字内容制作、系统平台搭建、信息发布、业务展示、供需对接及其他相关信息服务。除非本协议另有明确规定，本平台增加或强化目前服务的任何新功能、推出的新产品或新增的服务形态，均受本协议约束。</p>
<p class="none">2.2.用户了解并同意，本平台之服务、产品与资料仅按其当前实际状况提供，我们不对“服务”“资料”或“产品”等作任何明示或暗示的担保或保证，包括但不限于适销性、适合特定目的、持续可用性及不侵害他人权利等。对于因服务、产品或资料等所产生的任何直接、间接、附带或衍生性损失，我们在法律允许范围内不承担责任。<span></span></p>
<p class="none">2.3.您同意本平台有权根据运营需要制订关于使用本服务的一般措施及限制，包括但不限于审核规则、发布数量、展示周期、功能使用期限等，并有权根据实际情况进行调整。<span></span></p>
<p class="bold">3.账户及安全</p>
<p>3.1.账户注册</p>
<p>3.1.1.用户使用本平台部分功能前，需要拥有一个成功注册的账户。用户应使用真实、有效、合法的手机号码或其他平台认可的方式进行账户注册。</p>
<p>3.1.2.当用户申请企业身份、发布项目信息或使用部分特定服务时，可能需要提供真实姓名、公司名称、联系人、营业执照或其他证明材料。您应保证所提交资料真实、完整、有效。</p>
<p>3.1.3.成功注册或登录后，用户可进入账户页面修改个人或企业资料。出于安全性、合规要求及身份识别需要，部分初始注册信息或认证信息在特定情况下可能无法自行修改。</p>
<p>3.1.4.为保障账户安全及依法合规运营，本平台有权根据实际情况要求您完成实名认证、企业认证或其他必要审核。</p>
<p>3.2.账户安全</p>
<p>3.2.1.完成注册程序并成功注册后，您可使用注册手机号码和密码或验证码登录您的平台账号（下称“账号”）。账号使用权归您所有，但账号的保管和安全维护责任由您承担。</p>
<p>3.2.2.用户应妥善保管账户名、密码、验证码及其他身份识别凭证。因用户保管不善、主动转让、出借账号或其他非平台原因造成的损失，由用户自行承担；若发现账号遭到未获授权的使用或存在其他安全问题，请立即联系本平台。</p>
<p class="none">3.2.3.本平台将通过加密、访问控制、日志留存等合理安全措施保护用户信息，但您理解互联网环境中不存在绝对完善的安全措施。因黑客攻击、不可抗力或您的保管疏忽导致账号、密码遭他人非法使用的，我们将在法律规定范围内承担相应责任。<span></span></p>
<p class="bold">4.担保与保证</p>
<p>您明确了解并同意：</p>
<p>1）本协议任何规定均不会免除本平台因故意或重大过失造成您人身伤害或财产损失时依法应承担的责任；</p>
<p class="none">2）本平台不保证以下事项：</p>
<p class="none">•本服务完全符合您的特定要求；</p>
<p class="none">•本服务将不受干扰、及时提供、安全可靠或不会出错；</p>
<p class="none">•使用本服务取得的结果完全正确、完整或绝对可靠；</p>
<p class="none">•您经由本服务获得的任何产品、服务、资讯或其他信息均完全符合您的期望；</p>
<p class="none">3）您自行决定是否使用本服务及下载或取得任何资料，并自行承担因此产生的风险，包括但不限于设备损坏、数据丢失等后果；</p>
<p class="none">4）您自本平台或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本协议有明确规定，均不构成本协议以外的任何保证。<span></span></p>
<p class="bold">5.用户使用规范</p>
<p>5.1.对本平台拥有知识产权的内容、系统、页面、界面设计、版面框架、图片、文字、音视频、程序及其他资料，本平台仅授予您个人、不可转让、非独占的有限使用权。未经本平台或相关权利人事先书面许可，您不得复制、修改、改编、翻译、出租、出借、出售、传播、还原工程、反向编译、反向汇编或以其他方式非法使用本平台内容或技术成果。</p>
<p class="none">您在使用本平台服务过程中不得出现以下行为：</p>
<p class="none">1）发布虚假、夸大、误导性、侵权、违法违规或与实际业务无关的信息；</p>
<p class="none">2）擅自建立本平台镜像站点，抓取、复制、转载或批量使用平台内容；</p>
<p class="none">3）对平台程序、页面、接口、图像、文档等进行反编译、反汇编、破解或其他不当技术处理；</p>
<p class="none">4）使用任何自动化程序、插件、外挂、爬虫或未经授权的第三方工具登录、调用或干扰本平台服务；</p>
<p class="none">5）从事危害平台安全、破坏交易秩序、侵害他人合法权益或违反公序良俗的其他行为。</p>
<p>5.2.如您发现系统安全弱点、异常风险或可疑事件，应及时向本平台反馈，不得擅自测试、扩散或利用相关问题。</p>
<p class="bold">6.内容使用规范</p>
<p class="bold">6.1.本平台在服务中提供的内容，包括但不限于网页、界面设计、版面框架、文字、图片、音频、视频及其他资料，其知识产权归属于本平台或相关权利人所有。除另有说明外，本平台提供服务所依托的软件、系统及技术成果的著作权、专利权及其他知识产权均归本平台或依法授权方所有。</p>
<p class="bold">6.2.杭州笑口杏信息科技有限公司名称、本平台标识及相关产品、服务名称等，均受法律保护。未经本平台事先书面同意，您不得擅自删除、遮盖、修改、展示、使用或另行处理前述权利标识。</p>
<p class="none">6.3.您了解并同意，本服务及相关软件中含有受知识产权及其他法律保护的专有资料。未经本平台明确授权，您不得修改、出租、出借、出售、散布本服务或软件的任何部分或全部，亦不得据此制作衍生作品。<span></span></p>
<p class="bold">6.4.如您违反著作权法、商标法、专利法、反不正当竞争法及其他相关法律法规或本协议约定，您应自行承担因此给他人或本平台造成的损失及相应法律责任。</p>
<p class="bold">7.权益保护</p>
<p class="bold">本平台尊重他人的合法权益，包括但不限于知识产权、名誉权、商誉权、隐私权等，也要求您同样尊重他人合法权益。如您违反法律法规、监管要求、本协议约定或侵害他人合法权益，本平台有权删除相关内容、限制账号权限、暂停或终止服务，并保留追究法律责任的权利。</p>
<p class="bold">8.用户隐私政策</p>
<p class="bold">保护您的个人信息安全既是法律要求，也是本平台长期坚持的基本原则。您提供的注册资料及本平台留存的与您相关的信息将受到中国法律保护。本平台将根据中国法律、本协议及《隐私政策》的规定收集、存储、使用和保护您的个人信息。</p>
<p class="bold">9.服务变更、中断或终止</p>
<p class="none">9.1.本平台可能基于业务发展、监管要求、技术升级或运营管理需要对服务内容进行变更，也可能中断、暂停或终止部分或全部服务。</p>
<p class="none">9.2.鉴于网络服务的特殊性，包括但不限于服务器稳定性问题、网络攻击、系统维护或其他本平台无法控制的情形，您同意本平台有权在合理范围内中断或终止部分或全部服务。<span></span></p>
<p class="none">9.3.您理解，本平台需要定期或不定期对提供服务的平台、设备、线路或系统进行维护、升级或调整，因此造成服务在合理时间内中断的，本平台无需承担违约责任。<span></span></p>
<p class="none">9.4.如发生以下任一情形，本平台有权中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担责任：</p>
<p class="bold">1）您提供的资料不真实、不完整或已失效；</p>
<p class="bold">2）您违反法律法规、监管规则或本用户注册协议。<span></span></p>
<p class="none">9.5.您同意本平台可基于合理判断，在您长期未使用账户、涉嫌违规、存在安全风险或已违反本协议时，采取限制功能、移除内容、暂停使用、关闭或注销账号等措施。<span></span></p>
<p class="none">9.6.用户对网络服务的使用自行承担合理风险。本平台不就服务不中断、绝对安全、绝对无误作出保证，但会在合理范围内持续提升服务稳定性和安全性。<span></span></p>
<p class="none">9.7.因不可抗力或本平台不能控制的原因造成的服务中断或其他问题，本平台将在法律允许范围内免责。</p>
<p class="none">9.8.本平台页面中可能包含外部链接，对于外部链接指向内容的准确性、完整性和合法性，本平台不承担保证责任。</p>
<p class="none">9.9.用户理解并同意，本平台会尽力保障用户数据的存储安全，但不就数据绝对完整、永久保存作出承诺，包括但不限于以下情形：</p>
<p class="none">9.9.1.本平台有权根据实际情况自行决定用户数据的保存期限、存储空间和展示周期，用户应自行做好备份；</p>
<p class="none">9.9.2.因网络信号不稳定、带宽限制、第三方服务异常等原因导致登录、注册、资料同步、内容查看不稳定的，相关风险由用户自行承担；</p>
<p class="none">9.9.3.如用户注销平台账户，本平台有权根据法律法规及内部规则删除相关账户数据，且无义务向用户返还已删除数据。<span></span></p>
<p class="bold">10.国际使用之特别告知</p>
<p class="bold">您已了解互联网具有跨地域特性，如您在中华人民共和国境外使用本平台服务，还应同时遵守所在地有关网络行为、数据传输及内容管理的法律法规。</p>
<p class="bold">11.未成年人使用条款</p>
<p class="bold">如您为未成年人，请在法定监护人的陪同下仔细阅读本协议，并在取得法定监护人同意后使用本平台服务。未成年人及其监护人应按照法律及本协议规定承担相应责任。</p>
<p class="bold">12.服务条款的修改和服务修订</p>
<p class="none">12.1.本平台有权在必要时对本协议进行修改。如您不同意修改后的内容，您应停止使用本平台服务；如您继续使用，则视为接受修改后的协议。<span></span></p>
<p class="none">12.2.除对本协议的直接修改外，本平台针对某些特定服务通过网页公告、站内通知、短信、电话、电子邮件或其他合理方式作出的声明、通知、提示等内容，均视为本协议的一部分。<span></span></p>
<p class="bold">13.一般条款</p>
<p class="bold">13.1.本平台公布的《隐私政策》及与服务相关的其他规则、公告、说明均为本协议的有效组成部分，与本协议具有同等法律效力。</p>
<p class="bold">13.2.本用户注册协议及您与杭州笑口杏信息科技有限公司之间的关系，均适用中华人民共和国法律。因本服务、本协议或其他相关事项发生争议的，双方应先友好协商；协商不成的，应提交杭州笑口杏信息科技有限公司实际运营者所在地有管辖权的人民法院通过诉讼解决。</p>
<p class="bold">13.3.本平台未行使或执行本协议任何权利或规定，不构成对前述权利或规定的放弃。</p>
<p class="bold">13.4.如本协议任何条款被认定为无效或不可执行，不影响本协议其他条款的效力。</p>
<p class="bold">13.5.本协议标题仅为阅读方便而设，不影响条款含义及解释。</p>
<p class="none">如您对本协议内容有任何意见或建议，可以致电 13282812933 与我们联系。<span></span></p>
<div class="bold">
  <p class="none">再次郑重提示并说明：请您认真、仔细阅读《用户注册协议》和《隐私政策》各项内容，尤其应重点关注特别标注部分。若您已全部知悉并理解相关内容，请勾选“已阅读并同意《用户注册协议》《隐私政策》”。</p>
</div>
`
export default detail
